import { __awaiter } from "tslib";
import { RcsbQueryAnnotations, RcsbQueryGroupAnnotations, RcsbQueryGroupAnnotationsSumary } from "./RcsbQueryAnnotations";
import { RcsbQueryAlignment, RcsbQueryGroupAlignment } from "./RcsbQueryAlignment";
import { RcsbQueryEntryInstances } from "./RcsbQueryEntryInstances";
import { RcsbQueryMultipleEntityInstances } from "./RcsbQueryMultipleEntityInstances";
import { RcsbQueryGroup } from "./RcsbQueryGroup";
import { RcsbQueryMultipleEntriesProperties } from "./RcsbQueryMultipleEntriesProperties";
import { RcsbQueryInterfaceInstances } from "./RcsbQueryInterfaceInstances";
import { RcsbQueryAssemblyInterfaces } from "./RcsbQueryAssemblyInterfaces";
import { rcsbRequestClient } from "../RcsbRequest/RcsbRequestClient";
import { RcsbQueryMultipleInstanceSequences } from "./RcsbQueryMultipleInstanceSequences";
//TODO Implement a cache to store requests and avoid duplication
class RcsbClientClass {
    constructor(get) {
        this.rcsbQueryAnnotations = new RcsbQueryAnnotations(get.borrego);
        this.rcsbQueryGroupAnnotationsSummary = new RcsbQueryGroupAnnotationsSumary(get.borrego);
        this.rcsbQueryGroupAnnotations = new RcsbQueryGroupAnnotations(get.borrego);
        this.rcsbQueryAlignment = new RcsbQueryAlignment(get.borrego);
        this.rcsbQueryGroupAlignment = new RcsbQueryGroupAlignment(get.borrego);
        this.rcsbQueryEntityInstances = new RcsbQueryEntryInstances(get.yosemite);
        this.rcsbQueryMutipleEntityInstances = new RcsbQueryMultipleEntityInstances(get.yosemite);
        this.rcsbQueryEntryProperties = new RcsbQueryMultipleEntriesProperties(get.yosemite);
        this.rcsbQueryInterfaceInstances = new RcsbQueryInterfaceInstances(get.yosemite);
        this.rcsbQueryAssemblyInterfaces = new RcsbQueryAssemblyInterfaces(get.yosemite);
        this.rcsbQueryGroup = new RcsbQueryGroup(get.yosemite);
        this.rcsbQueryMultipleInstanceSequences = new RcsbQueryMultipleInstanceSequences(get.yosemite);
    }
    requestRcsbPdbAnnotations(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryAnnotations.request(requestConfig);
        });
    }
    requestRcsbPdbGroupAnnotationsSummary(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryGroupAnnotationsSummary.request(requestConfig);
        });
    }
    requestRcsbPdbGroupAnnotations(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryGroupAnnotations.request(requestConfig);
        });
    }
    requestAlignment(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryAlignment.request(requestConfig);
        });
    }
    requestGroupAlignment(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryGroupAlignment.request(requestConfig);
        });
    }
    requestEntityInstances(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryEntityInstances.request(requestConfig);
        });
    }
    requestMultipleEntityInstances(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryMutipleEntityInstances.request(requestConfig);
        });
    }
    requestGroupInfo(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryGroup.request(requestConfig);
        });
    }
    requestMultipleEntriesProperties(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryEntryProperties.request(requestConfig);
        });
    }
    requestInterfaceInstances(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryInterfaceInstances.request(requestConfig);
        });
    }
    requestAssemblyInterfaces(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryAssemblyInterfaces.request(requestConfig);
        });
    }
    requestMultipleInstanceSequences(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.rcsbQueryMultipleInstanceSequences.request(requestConfig);
        });
    }
}
export const rcsbClient = new RcsbClientClass({ borrego: () => rcsbRequestClient.borrego, yosemite: () => rcsbRequestClient.yosemite });
//# sourceMappingURL=RcsbClient.js.map